import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

function FeatureUnavailableModal({ isOpen, onClose, title = 'Feature Unavailable', message = 'This feature is not yet available. Please check back later or contact support for more information.', primaryButtonText = 'Understood' }) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm"
      onClick={handleBackdropClick}
    >
      <div className="relative bg-gradient-to-br from-[#0a1628] to-[#1a2448] border border-[#4cc3e9]/30 rounded-xl shadow-2xl max-w-md w-full mx-4 p-6">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white/70 hover:text-white transition-all duration-200"
        >
          <FontAwesomeIcon icon={faTimes} className="text-sm" />
        </button>

        {/* Content */}
        <div className="text-center">
          {/* Icon */}
          <div className="mb-4 flex justify-center">
            <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-2xl text-yellow-400" />
            </div>
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-white mb-2">
            {title}
          </h3>

          {/* Message */}
          <p className="text-white/80 mb-6 leading-relaxed">
            {message}
          </p>

          {/* Action button */}
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105"
          >
            {primaryButtonText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FeatureUnavailableModal;
